import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Slider from "react-slick";
import AOS from "aos";
import "aos/dist/aos.css";
import CountUp from "react-countup";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Stats.css";

const Stats = () => {
  const [githubStats, setGithubStats] = useState([]);
  const [leetcodeStats, setLeetcodeStats] = useState({});
  const [loading, setLoading] = useState(true);
  const sliderRef = useRef(null); // Create a reference for the slider

  const stats = [
    { label: "Years of Experience", value: 2 },
    { label: "Projects Completed", value: 5 },
    { label: "Certificates Earned", value: 6 },
    { label: "Lines of Code Written", value: 50000 },
  ];

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    const fetchStats = async () => {
      try {
        const githubRes = await axios.get(
          "https://api.github.com/users/piyushagarwal14/repos"
        );
        setGithubStats(githubRes.data);

        const leetcodeRes = await axios.get(
          "https://leetcode-stats-api.herokuapp.com/piyushagarwalplay"
        );
        setLeetcodeStats(leetcodeRes.data);
      } catch (err) {
        console.error("API fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const testimonials = [
    {
      name: "K",
      role: "Client",
      feedback:
        "Piyush is detail-oriented and brings energy to the team. Excellent problem-solver!",
    },
    {
      name: "Ajit",
      role: "Client",
      feedback:
        "Delivered our website ahead of schedule — sleek, responsive, and fast.",
    },
    {
      name: "Saroj",
      role: "Client",
      feedback:
        "Strong design sense, clean code, and always eager to learn new technologies.",
    },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    centerMode: true,
    centerPadding: "0px",
  };

  // Custom next and prev buttons
  const handleNext = () => {
    sliderRef.current.slickNext();
  };

  const handlePrev = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <div className="stats-wrapper">
      {/* Heading */}
      <h2 className="stats-heading" data-aos="fade-up">
        Stats & <span className="text-highlight">Testimonials</span>
      </h2>

      {/* Stats Row */}
      <div className="stats-row">
        {stats.map((item, index) => (
          <div
            className="stat-card"
            key={index}
            data-aos="zoom-in"
            data-aos-delay={index * 150}
          >
            <h3 className="stat-value">
              <CountUp
                start={0}
                end={item.value}
                duration={2.5}
                separator=","
              />
              {item.label.includes("Code") && "+"}
            </h3>
            <p className="stat-label">{item.label}</p>
          </div>
        ))}

        {!loading && githubStats.length > 0 && (
          <div className="stat-card" data-aos="zoom-in" data-aos-delay="600">
            <h3 className="stat-value">
              <CountUp start={0} end={githubStats.length} duration={2.5} />
            </h3>
            <p className="stat-label">GitHub Repositories</p>
          </div>
        )}

        {/* {!loading && leetcodeStats.totalSolved !== undefined && (
          <div className="stat-card" data-aos="zoom-in" data-aos-delay="750">
            <h3 className="stat-value">
              <CountUp
                start={0}
                end={leetcodeStats.totalSolved}
                duration={2.5}
              />
            </h3>
            <p className="stat-label">LeetCode Problems Solved</p>
          </div>
        )} */}
      </div>

      {/* Testimonials */}
      <div className="testimonial-section" data-aos="fade-up">
        <h3 className="testimonial-heading">What People Say</h3>
        <Slider ref={sliderRef} {...sliderSettings}>
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card">
              <p className="testimonial-text">“{t.feedback}”</p>
              <p className="testimonial-author">
                — {t.name}, <span>{t.role}</span>
              </p>
            </div>
          ))}
        </Slider>

        {/* Custom Navigation Buttons */}
        <div className="slider-buttons">
          <button className="slider-btn prev-btn" onClick={handlePrev}>
            ❮
          </button>
          <button className="slider-btn next-btn" onClick={handleNext}>
            ❯
          </button>
        </div>
      </div>
    </div>
  );
};

export default Stats;
